const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export function formatMoney(amount: number) {
  return currencyFormatter.format(amount);
}

export function maskEmail(email: string): string {
  const address = email.trim();
  const at = address.indexOf("@");
  return at > 0 ? `${address.slice(0, Math.min(2, at))}***${address.slice(at)}` : "***";
}
